import { Button } from "@mui/material";
import useMultifactorAuthSettings from "../hooks/useMultifactorAuthSettings";
import { en } from "@toolpad/core";

type MfaActionsButtonProps = {
  status: ReturnType<typeof useMultifactorAuthSettings>["state"]["status"];
  handleAddTotp: ReturnType<typeof useMultifactorAuthSettings>["handleAddTotp"];
  handleRemoveTotp: ReturnType<
    typeof useMultifactorAuthSettings
  >["handleRemoveTotp"];
  handleCancelEnrollment: ReturnType<
    typeof useMultifactorAuthSettings
  >["handleCancelEnrollment"];
  mfaData: ReturnType<typeof useMultifactorAuthSettings>["mfaData"];
  enrolledInMFA: boolean;
};

export default function MfaActionsButton({
  status,
  handleAddTotp,
  handleRemoveTotp,
  handleCancelEnrollment,
  mfaData,
  enrolledInMFA,
}: MfaActionsButtonProps) {
  if (status === "pending") {
    return (
      <Button variant="outlined" loading={true} loadingPosition="start">
        Generating
      </Button>
    );
  }

  // If the user is not enrolled in MFA and there is an ongoing enrollment (mfaData is set), show "Cancel" button
  if ((!enrolledInMFA && mfaData) || status === "requires recent login") {
    return (
      <Button variant="outlined" color="error" onClick={handleCancelEnrollment}>
        Cancel
      </Button>
    );
  }

  if (
    enrolledInMFA &&
    (status === "mfa required" || status === "mfa verifying")
  ) {
    return (
      <Button
        variant="outlined"
        loading={status === "mfa verifying"}
        loadingPosition="start"
        color="error"
      >
        Cancel
      </Button>
    );
  }

  // If the user is enrolled in MFA, show "Remove" button
  if (enrolledInMFA) {
    return (
      <Button variant="contained" color="primary" onClick={handleRemoveTotp}>
        Remove
      </Button>
    );
  }

  // If the user is not enrolled in MFA and there is no ongoing enrollment, show "Add" button
  return (
    <Button variant="contained" color="primary" onClick={handleAddTotp}>
      Add
    </Button>
  );
}
